import arrayUtils from '../../../../../EbaySweden.TouchWeb/Areas/Selling/static/script/app_react/utils/array-utils';
import 'underscore';

var initialState = null;

export default (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case 'SET_TEMPLATES':
            if (action.payload) {
                state = arrayUtils.shallowCopyArrayObjects(action.payload);
            } else {
                state = null;
            }
            break;
        case 'UPDATE_TEMPLATE_IN_LIST':
            if (state) {
                state = arrayUtils.shallowCopyArrayObjects(state);
                let index = _.findIndex(
                    state,
                    template =>
                        template.templateId == action.template.templateId
                );
                if (index > -1) {
                    const images = action.template.images;
                    const image = images.length > 0 ? images[0] : {};
                    state[index].templateId = action.template.templateId;
                    state[index].name = action.template.templateName;
                    state[index].shortDescription =
                        action.template.shortDescription;
                    state[index].imageUrl = image.imageUrl;
                    state[index].imageRotationDegrees =
                        image.draftImage && image.draftImage.rotationDegrees;
                }
            }
            break;
    }
    return state;
};
